import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { PageForbiddenComponent } from "src/app/modules/error-page/components/403/page-forbidden.component";

const routes: Routes = [
  {
    path: "PageForbidden/:targetUrl",
    component: PageForbiddenComponent,
    data: { title: "403 Forbidden" },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ErrorPageRoutingModule {}
